export default __webpack_public_path__ + "static/media/phone.fa1d8883.svg";